const leadingZero = num => (num < 10 ? "0" + num : num);

export default leadingZero;
